export default "__VITE_ASSET__02d9f674__"